module.exports = __webpack_public_path__ + "img/step_design.c10ec1c1.png";